import { MiddlewareAPI, Dispatch, Action } from 'redux';

import { MultiAppAuthenticationInfosActionKeys, checkSession } from '../../containers/MultiAppAuthentication/actions';
import UserAgentUtils from '../../utils/userAgent';
import { StoreState } from '../../reducers';

function sessionChecker() {
	return (api: MiddlewareAPI<StoreState>) => (next: Dispatch<StoreState>) => (action: Action) => {
		if (!api) {
			return next(action);
		}

		const {
			galleryInfos: { isConfigLoaded },
			multiAppAuthenticationInfos: { credentials, oneSessPerUser },
			profile,
		} = api.getState();
		const isLoggedIn = !!(credentials && credentials.login);
		// in mobile app we get flag oneSessPerUser in appLogin call
		// in browser version external login page is used so this flag is gotten from getProfileInfo call
		const shouldCheckSession = UserAgentUtils.isMobileApp
			? oneSessPerUser
			: profile.oneSessPerUser;

		if (
			isConfigLoaded &&
			isLoggedIn &&
			shouldCheckSession &&
			UserAgentUtils.isOnline() &&
			action.type !== MultiAppAuthenticationInfosActionKeys.TOGGLE_CHECK_SESSION_STATUS
		) {
			api.dispatch(checkSession());
		}

		return next(action);
	};
}

export default sessionChecker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/middlewares/sessionChecker.ts